import { useState } from "react";
import { MessageCircle, Copy, Check } from "lucide-react";
import { toast } from "sonner";

export function buildWhatsAppMessage(profile, pillars) {
  const s = profile.scores;
  const pri = pillars[profile.priority];
  return (
    `Ciao Elena! Ho completato il test Be Woman.\n\n` +
    `Il mio punto di partenza: ${pri.name} (${pri.subtitle}).\n` +
    `Archetipo: ${profile.archetype.name}.\n\n` +
    `Punteggi:\n` +
    `• Cuore: ${s.cuore}/9\n` +
    `• Fitness: ${s.fitness}/9\n` +
    `• Beauty: ${s.beauty}/9\n` +
    `• Realizzazione: ${s.realizzazione}/9\n\n` +
    `Vorrei una consulenza per ripartire da me. 💗`
  );
}

export function WhatsAppBox({ profile, pillars, whatsappNumber }) {
  const [copied, setCopied] = useState(false);
  const message = buildWhatsAppMessage(profile, pillars);
  const waLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(message);
      setCopied(true);
      toast.success("Messaggio copiato");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Impossibile copiare");
    }
  };

  return (
    <div
      data-testid="whatsapp-consultation-box"
      className="rounded-2xl border border-[#E32C8C]/35 bw-card bg-[#2A0A1B] p-5 shadow-[0_4px_20px_rgba(74,18,48,0.05)]"
    >
      <div className="flex items-center gap-3 mb-4">
        <span className="w-14 h-14 rounded-full overflow-hidden shrink-0 border-2 border-[#6B2247]">
          <img src="/elena.jpg?v=2" alt="Elena" className="w-full h-full object-cover" style={{ objectPosition: "center top" }} />
        </span>
        <div>
          <h3 className="font-serif text-2xl font-semibold text-[#F6DCEA] leading-none">
            Parla con Elena
          </h3>
          <p className="text-sm text-[#EAC6D9] mt-1">
            La tua coach. Ecco il messaggio già pronto:
          </p>
        </div>
      </div>
      <div className="rounded-xl bg-black/30 p-4 text-sm text-[#F6DCEA] whitespace-pre-line mb-4 max-h-44 overflow-auto bw-scroll">
        {message}
      </div>
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-elena-btn"
        className="w-full bg-gradient-to-r from-[#E32C8C] to-[#8E1A52] text-white font-semibold py-3.5 px-6 rounded-full shadow-lg shadow-[#E32C8C]/25 bw-glow hover:opacity-95 active:scale-[0.98] transition-all flex items-center justify-center gap-2 mb-2.5"
      >
        <MessageCircle className="w-5 h-5" /> Scrivi a Elena su WhatsApp
      </a>
      <button
        type="button"
        onClick={copy}
        data-testid="copy-message-btn"
        className="w-full bg-[#00000000] text-[#F6DCEA] border border-[#E32C8C]/30 font-semibold py-3 px-6 rounded-full hover:bg-[#401431] transition-all flex items-center justify-center gap-2"
      >
        {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />} Copia il messaggio
      </button>
    </div>
  );
}
